import { HouseImgIcon } from "./HouseImgIcon";

export const HouseAuthor = ({ authorImgUrl, houseName, differenceTime, alert = false }) => (
    <div className="news-header-author flex flex-row items-center md:ml-2">
        <div className="rounded-full overflow-hidden h-7 w-7 mr-1">
            {authorImgUrl ?
                <img
                    className="object-cover"
                    src={authorImgUrl}
                    alt=""
                /> :
                <HouseImgIcon className="bg-primary text-white rounded-full" />
            }
        </div>
        <label className={`font-bold text-xs mx-1 ${alert ? "text-white" : "text-black"}`}>
            {houseName}
        </label>
        <span className={`mx-1 ${alert ? "text-white" : "text-primary"}`}>|</span>
        <label className={`mx-1 font-normal text-xs ${alert ? "text-white" : "text-black opacity-40"}`}>
            {differenceTime}
        </label>
    </div>
)